import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE_URL;

if (!baseURL) {
  console.error("❌ ENV ERROR: REACT_APP_API_BASE_URL missing");
  throw new Error("API base URL not set");
}

console.log("✅ API BASE:", baseURL);
console.log("✅ TENANT:", process.env.REACT_APP_TENANT_ID);

const api = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// ✅ Attach token + tenant automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // ✅ Inject tenant into body
    if (config.method === "post" || config.method === "put" || config.method === "patch") {
      config.data = {
        ...config.data,
        tenant: Number(process.env.REACT_APP_TENANT_ID || 3),
      };
    }

    console.log("🚀 API:", config.baseURL + config.url);
    console.log("📦 Payload:", config.data);

    return config;
  },
  (error) => Promise.reject(error)
);

export const apiCall = {
  get: (url, config = {}) => api.get(url, config).then((res) => res.data),
  post: (url, data, config = {}) => api.post(url, data, config).then((res) => res.data),
  put: (url, data, config = {}) => api.put(url, data, config).then((res) => res.data),
  patch: (url, data, config = {}) => api.patch(url, data, config).then((res) => res.data),
  delete: (url, config = {}) => api.delete(url, config).then((res) => res.data),
};

export default api;